module.exports = __webpack_public_path__ + "static/media/dsp_background_dt.e00727b8.png";